__turbopack_context__.v({
  "bar": "OSnIQq_bar",
  "container": "OSnIQq_container",
  "floater": "OSnIQq_floater",
  "icon": "OSnIQq_icon",
  "tab": "OSnIQq_tab",
});
